<template>
  <div>
    <v-app>
      <v-container fluid fill-height>
       <v-content>
        <v-layout align-center justify-center>
          <v-flex xs7 >
            <v-container class="text-xs-center">
              <v-alert :value="true" class="success" v-if="message"> <span> {{ message }} </span> </v-alert>

              <v-alert
                value="error" v-if="error"
                type="warning"
                outline
              > <span> {{ error }} </span>
              </v-alert>

              <v-card class="elevation-12">

                <v-toolbar dark color="green darken-1">
                  <v-toolbar-title>One Time Pin</v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                  <p> One Time Pin has been sent to your email, enter the Pin to proceed </p>
                  <v-form>
                    <v-text-field name="One Time Pin" label="OTP" v-model="otp.token" type="text">
                    </v-text-field>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                     <v-btn @click="resendOTP" color="green lighten-2">Resend Token</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @keyup.enter="validateOTP" @click="validateOTP" color="green darken-1">Submit</v-btn>
                </v-card-actions>

                 <div v-if=response class="text-red">
                    <p class="vertical-5p lead">{{response}}</p>
                </div>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-content>
    </v-container>
  </v-app>
 </div>
</template>
<script>
import axios from 'axios'
import config from '../config'
import store from '../store'

export default {
  name: 'tokenvalidate',
  data(router) {
    return {
      section: 'tokenvalidate',
      loading: '',
      otp: {token: '', userId: 0},
      response: '',
      message: '',
      error: ''
    }
  },
  methods: {
    validateOTP() {
      this.toggleLoading()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      var url = config.serverURI + '/token/validate-otp'
      var token = store.state.tempToken
      this.otp.userId = this.$route.params.id

      axios
        .post(url, this.otp, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          this.toggleLoading()

          var data = response.data
          console.log(data)
          /* Setting user in the state and caching record to the localStorage */
          if (data.token) {
            var token = 'Bearer ' + data.token

            this.$store.commit('SET_USER', data.user)
            this.$store.commit('SET_TOKEN', token)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(data.user))
              window.localStorage.setItem('token', token)
            }

            this.$router.push(data.redirect ? data.redirect : '/')
          } else {
            this.error = data.error
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
          this.error = error.response.data.message
          this.toggleLoading()
        })
    },
    resendOTP() {
      var url = config.serverURI + '/token/resend-otp'
      var token = store.state.tempToken
      this.otp.userId = this.$route.params.id

      axios
        .post(url, this.otp, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          var data = response.data
          this.message = data.message
        })
        .catch(error => {
          console.log(error)
          this.error = error.response.data.message
        })
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
    }
  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// tokenvalidate.vue?3f0d34d1